import axios from './http.js'
// 登录
// export function login(data) {
//     return axios({
//         url: '/api/v1/blade-user/ground/user-ground/v2/login',
//         method: 'post',
//         params: data
//     })
// }

// 查询轮播图
export function selectPic() {
    return axios({
        url: '/selectAllPic',
        method: 'get',
    })
}

//查询产品介绍
export function getProductList() {
    return axios({
        url: '/product/getProductList',
        method: 'get',
    })
}

//查询6条新闻
export function getSixNews() {
    return axios({
        url: '/news/getSixNews',
        method: 'get',
    })
}

//查询所有数据
export function getAllNews(){
    return axios({
        url: '/news/getAllNew',
        method: 'get',
    })
}

//查询里程碑
export function getMilestoneList() {
    return axios({
        url: '/milestone/getMilestoneList',
        method: 'get',
    })
}


//查询荣誉
export function getHonor() {
    return axios({
        url: '/honor/getHonor',
        method: 'get',
    })
}

//合作伙伴
export function getPartner(){
    return axios({
        url: '/partner/getAllPartner',
        method: 'get',
    })
}
